import React from 'react'
import { css } from '@emotion/core'
import { LicenseStyled } from '../theme/globalStyle'

const sStyle = css`
    border: 0;
    margin: 0;
    padding: 0;
`

const License = () => (
    <LicenseStyled>
        <a rel="license" href="https://creativecommons.org/licenses/by-nc/4.0/"><img alt="Licencia de Creative Commons" css={sStyle} src="https://i.creativecommons.org/l/by-nc/4.0/80x15.png"/></a>
    </LicenseStyled>
   
)

export default License
